import { render } from "./TokenList.vue?vue&type=template&id=a7c0598a&scoped=true"
import script from "./TokenList.vue?vue&type=script&lang=js"
export * from "./TokenList.vue?vue&type=script&lang=js"

import "./TokenList.vue?vue&type=style&index=0&id=a7c0598a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7c0598a"]])

export default __exports__